import React, { type FC, type ReactNode } from 'react'
import { type SxProps, TableCell, TableRow, type Theme, Typography } from '@mui/material'

import { isTranslation, Translation } from '../../../../domain'

import { useTranslator } from '../../Internationalization'
import { StateBlock } from '../StateBlock'
import { useAppliedSearch, useColspan, useTranslations } from './State'

const bodyMessageCellStyle: SxProps<Theme> = { px: 3, py: 6 }
export const stateBlockCellStyle: SxProps<Theme> = { p: 0 }

export const EmptyTableBody: FC = () => {
    const translator = useTranslator()
    const search = useAppliedSearch()
    const colSpan = useColspan()

    const translations = useTranslations()
    const { noResultsOrEmptyTable = Translation.NO_RESULTS_FOUND, emptyTable = noResultsOrEmptyTable, noResults = noResultsOrEmptyTable } = translations

    /** Only a table whose caller names what it lists gets the first-run block; generic "no results" texts stay a one-liner */
    const showsBlock = !search && translations.emptyTable !== undefined

    const target: ReactNode = search ? noResults : emptyTable
    const content = isTranslation(target) ? translator.formatTranslation(target) : target

    return (
        <TableRow data-testid="empty-table-body">
            {showsBlock
                ? (
                    <TableCell colSpan={colSpan} sx={stateBlockCellStyle}>
                        <StateBlock title={content} />
                    </TableCell>
                )
                : (
                    <TableCell colSpan={colSpan} sx={bodyMessageCellStyle}>
                        <Typography variant="body2" component="p" color="grey.600" textAlign="center">
                            {content}
                        </Typography>
                    </TableCell>
                )}
        </TableRow>
    )
}
